(function () {
    let lienDeconnexion = document.querySelector('.js-gestmax-deconnexion');
    if (lienDeconnexion) {
        lienDeconnexion.addEventListener('click', function (e) {
            e.preventDefault();
            const redirectUrl = this.href;
            // Création de l'overlay
            const overlay = document.createElement('div');
            overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:9999;display:flex;justify-content:center;align-items:center;';
            // Création du message
            const message = document.createElement('div');
            message.style.cssText = 'background:#fff;padding:20px;border-radius:5px;box-shadow:0 2px 10px rgba(0,0,0,0.2);font-family:sans-serif;';
            message.innerText = 'Déconnexion en cours, veuillez patienter…';
            overlay.appendChild(message);
            document.body.appendChild(overlay);
            // Gestion de la redirection (unicité garantie)
            let isRedirected = false;
            const doRedirect = function () {
                if (!isRedirected) {
                    isRedirected = true;
                    window.location.href = redirectUrl;
                }
            };
            const urlLogout = lienDeconnexion.dataset.urllogout;
            fetch(urlLogout, {
                method: 'GET',
                mode: 'no-cors',
                credentials: 'include'
            })
                .then(doRedirect)
                .catch(function (error) {
                    console.error('Erreur lors de la déconnexion Gestmax', error);
                    doRedirect();
                });
            // Timeout de sécurité 10s
            setTimeout(doRedirect, 10000);
        });
    }
})();